import { createRouter, createWebHistory } from "vue-router";

import { admin_routes } from "./admin";
import { web_routes } from "./web";

const routes = [...admin_routes, ...web_routes];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

// ✅ Global afterEach hook
router.afterEach((to) => {
  const baseTitle = "Agent BimaGrow";

  // ✅ Set Page Title (ONLY ONCE)
  const pageTitle = to.meta?.title
    ? `${to.meta.title} | ${baseTitle}`
    : baseTitle;

  document.title = pageTitle;

  // ✅ Google Analytics Page Tracking (SPA fix)
  if (typeof window.gtag === "function") {
    window.gtag("config", "G-596XB9VGJX", {
      page_path: to.fullPath,
      page_title: pageTitle,
      page_location: window.location.href,
    });
  }
});
